<template>
    <div class="statistic-query">
        <div class="statistic-query-title">
            <div class="statistic-title-item">
                <el-radio-group v-model="totalSelect" @change="totalSelectEvent">
                    <el-radio-button label="程序"></el-radio-button>
                    <el-radio-button label="手动"></el-radio-button>
                </el-radio-group>
            </div>

            <div class="statistic-title-item">
                <label for="">API:</label>
                <el-select multiple collapse-tags placeholder="请选择" size="medium" v-model="apiList1" @change="apiSelectEvent">
                    <el-option :label="'不选'" :value="'all'"></el-option>
                    <el-option :label="'总和'" :value="'总和'"></el-option>
                    <el-option v-for="(api, index) in apiNameList" :key="index" :label="api.name" :value="api.id"></el-option>
                </el-select>
            </div>
            <div class="statistic-title-item">
                <label for="">币种:</label>
                <el-select multiple collapse-tags placeholder="请选择" v-model="currencyList1" @change="apiSelectEvent">
                    <el-option :label="'不选'" :value="'all'"></el-option>
                    <el-option :label="'总和'" :value="'总和'"></el-option>
                    <!-- <el-option :label="'全选'" :value="'total'"></el-option> -->
                    <el-option v-for="(currency, index) in currencyList" :key="index" :value="currency"  :label="currency"></el-option>
                </el-select>
            </div>
            <div class="statistic-title-item">
                <label for="">任务:</label>
                <el-select multiple collapse-tags v-model="taskList1" class="statistic-task-select">
                    <el-option :label="'不选'" :value="'all'"></el-option>
                    <el-option :label="'总和'" :value="'总和'"></el-option>
                    <el-option v-for="(task, index) in taskList" :key="index" :value="task.id" :label="task.name"></el-option>
                </el-select>
            </div>
            <div class="statistic-title-item">
                <label for="">日期:</label>
                <el-date-picker v-model="timeSelect" @change="timeSelectEvent" type="daterange" value-format="yyyy-MM-dd" align="right" size="mini"
                start-placeholder="开始日期" range-separator="-"
                end-placeholder="结束日期">
                </el-date-picker>
                <!-- <input class="date-step-length" placeholder="步长" v-model="stepLenData" @input="stepLenEvent"> -->
            </div>
            <div class="statistic-title-item">
                <button class="statistic-title-btn" @click="querySubmit"><i class="fa fa-search" aria-hidden="true"></i>查询</button>
                <span class="statistic-is-show" @click="tableShow = false" v-if="tableShow == true"><i class="fa fa-chevron-down" aria-hidden="true"></i></span>
                <span class="statistic-is-show" @click="tableShow = true" v-else><i class="fa fa-chevron-right" aria-hidden="true"></i></span>
            </div>
        </div>
        <div class="statistic-table" v-if="typeof statisticData !== 'undefined'" v-show="tableShow">
            <table v-if="totalParam == 0">
                <thead>
                    <tr v-if="typeof statisticData['manual'] !== 'undefined'">
                        <th v-for="(item, index) in statisticData['manual'][0]" :key="index">{{keyJudge(index)}}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in statisticData['manual']" :key="index">
                        <td v-for="(item1, index1) in item" :key="index1">{{valueJudge(item1, index1)}}</td>
                    </tr>
                </tbody>
            </table>
            <table v-else-if="totalParam == 1">
                <thead>
                    <tr v-if="typeof statisticData['automatic'] !== 'undefined'">
                        <th v-for="(item, index) in statisticData['automatic'][0]" :key="index">{{keyJudge(index)}}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in statisticData['automatic']" :key="'1-'+index">
                        <td v-for="(item1, index1) in item" :key="index1">{{valueJudge(item1, index1)}}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
/* eslint-disable */
import { get } from '@/api/index'
import { mapState, mapActions } from 'vuex'
import { getDateTime, deepClone } from '@/utils/common'

export default {
    data() {
        return {
            statisticData: {}, 
            statisticData1: [],
            tagList: ['API', '币种', '日期', '任务'],
            totalSelect: '程序',
            timeSelect: [],
            currencyList: ['eos', 'btc', 'etc', 'bch', 'eth', 'ltc', 'xrp', 'bsv', 'trx'],
            taskSelect: 0,
            totalParam: 1,
            apiSelect: 2,
            currencySelect: 'eos',
            paramData: {},
            totalStatisticData: {},
            currencyTotalData: {},

            apiList1: [2],
            currencyList1: ['eos', 'btc', 'etc', 'bch'],
            taskList1: ['all'],
            stepLenData: '',
            tableShow: true,
        }
    },
    mounted() {
        if (this.apiNameList.length == 0) {
            this.getApiList();
        }
    },
    computed: {
        ...mapState([
            'taskList',
            'apiNameList'
        ])
    },
    methods: {
        ...mapActions([
            'getApiList'
        ]),
       // 获取订单统计数据
        getOrderData() {
            var param1 = {
                'apis': JSON.stringify(this.apiList1),
                'days': JSON.stringify(this.timeSelect),
                'currencys': JSON.stringify(this.currencyList1),
                'tasks': JSON.stringify(this.taskList1)
            }
            var param = this.paramJudge(param1);

            if (this.timeSelect !== null && this.timeSelect.length !== 0) {
                var date_list = [0];
                var date_list_new = date_list.concat(this.timeSelect);
                date_list_new[1] = this.timeSelect[0] + ' 00:00:00';
                date_list_new[2] = this.timeSelect[1] + ' ' + getDateTime()+':00';
                param['days'] = JSON.stringify(date_list_new);
            } else {
                delete param['days'];
            }
            
            var url = 'http://107.149.104.7:9999/web/query/order/SDC';
            get(url, param).then(resp => {
                if (resp.code == 200) {
                    this.paramData = param;
                    this.statisticData = resp.data;
                } else {
                    this.$notify.error({
                        message: resp.info,
                        title: '提示',
                        offset: 100
                    })
                }
            })
        },

        // 数据表示时间
        totalSelectEvent() {
            if (this.totalSelect == '程序') {
                this.totalParam = 1;
            } else {
                this.totalParam = 0;
            }
            this.getOrderData();
        },

        // api select 事件
        apiSelectEvent() {
            // this.getOrderData();
            // console.log(this.apiList1)
        },



        // 币种 select 事件
        currencySelectEvent() {
            // this.getOrderData();
        },

        // 日期选择
        timeSelectEvent() {
    
        }, 
        // 获取所有的apiid
        getApiIdList(apiList) {
            var apiIdList = [];
            for (var i in apiList) {
                apiIdList.push(apiList[i].id)
                // apiIdList += apiList[i].id + ',';
            }
            return apiIdList;
        },

        // 任务选择事件
        taskSelectEvent() {
            // this.getOrderData();
        },
        // 统计数值处理
        valueJudge(data, index1) {
            if (data == null) return 'NULL';
            else if (index1 == 'currency' || index1 == 'api_id' || index1 == 'task_id') return data;
            return Number(data).toFixed(2);
        },

        // 字段名称转译
        keyJudge(name) {
            if (name == 'fu_more') return '多';
            else if (name == 'fu_empty') return '空';
            else if (name == 'ss_sell') return '卖';
            else if (name == 'ss_buy') return '买';
            else if (name == 'api_id') return 'API';
            else if (name == 'currency') return '币种';
            else if (name == 'pool') return '价差';
            else if (name == 'pool_accounted') return '价差比';
            else if (name == 'more') return '多/总';
            else if (name == 'empty') return '空/总'
            return name;
        },

        // 步长选择事件
        stepLenEvent() {
            console.log(this.stepLenData);
        },

        // 统计数据参数判断
        paramJudge(data) {
            var param = {};
            var condition_obj = {
                'apis': this.apiList1,
                'currencys': this.currencyList1,
                'tasks': this.taskList1,
            }

            Object.keys(condition_obj).forEach(key => {
                if (condition_obj[key].indexOf('all') !== -1) {
                    delete condition_obj[key];
                    delete param[key];
                } else {
                    param[key] = condition_obj[key];
                    if (condition_obj[key].indexOf('总和') !== -1) {
                        // 如果有总和，值为 0
                        var value_index = condition_obj[key].indexOf('总和');
                        var value_array = [0];
                        condition_obj[key].splice(value_index, 1)
                        var value_total = value_array.concat(condition_obj[key])
                        param[key] = JSON.stringify(value_total);
                    } else {
                        // 值为 条件，值为 1
                        var value_array = [1]
                        var value_total = value_array.concat(condition_obj[key])
                        param[key] = JSON.stringify(value_total);
                    }
                } 
            })
            return param;
        },

        // 查询
        querySubmit() {
            this.getOrderData();
        },

        // 表格隐藏显示
        tableIsShow(flag) {
            console.log(flag)
        }
    }
}
</script>

<style lang="scss">
    .el-select-dropdown__item{
        height: 26px;
        line-height: 26px;
        span{
            font-size: 12px;
        }
    }
    .statistic-query{
        .statistic-query-title{
            display: flex;
            justify-content: flex-start;
            flex-wrap: wrap;
            padding: 10px;
            color: #a8a7a9;
            background-color: #1e1e1e;
            .statistic-title-item{
                margin: 5px 0;
                .statistic-is-show{
                    cursor: pointer;
                }
                .statistic-title-btn{
                    padding: 3px 5px;
                    margin-left: 5px;
                    border-radius: 3px;
                    outline: none;
                    border: 1px solid #333333;
                    background-color: #333333;
                    color: #a8a7a9;
                    margin-right: 10px;
                }
                .statistic-title-btn:hover{
                    cursor: pointer;
                    color: #fff;
                }
                label{
                    color: #a8a7a9;
                    margin-right: 5px;
                }
                select{
                    padding: 3px 10px;
                    outline: none;
                    border: 1px solid #333333;
                    border-radius: 2px;
                    background-color: #333333;
                    color: #a8a7a9;
                    vertical-align: middle;
                }
                .el-radio-button__inner{
                    padding: 5px 10px;
                    background-color: #333333;
                    border-color: #333333;
                    box-shadow: none;
                }
                .el-tag.el-tag--info{
                    background-color: #383434;
                    border-color: #383434;
                }
                .el-range-input{
                    background-color: #2A2D2E;
                }
                .el-range-separator{
                    color: #a8a7a9;
                }
                .el-input__inner{
                    height: 26px;
                    line-height: 26px;
                    background-color: #2A2D2E;
                    border-color: #2A2D2E;
                }
                .el-select__caret{
                    height: 26px;
                    line-height: 26px;
                }
                .el-select{
                    min-width: 250px;
                }
                .statistic-task-select{
                    min-width: 320px;
                }
                .date-step-length{
                    width: 50px;
                    font-size: 12px;
                    height: 26px;
                    line-height: 26px;
                    outline: none;
                    border-radius: 3px;
                    border: 1px solid #000;
                    vertical-align: middle;
                    padding: 0 3px;
                }
                .el-date-editor{
                    padding: 0;
                    padding-left: 5px;
                }
            }
        }
        .statistic-table{
            table{
                width: 100%;
                border-collapse: collapse;
                tbody{
                    tr:nth-child(even) {
                        background-color: #262829;
                    }
                    tr{
                        td{
                            padding: 8px 5px;
                        }
                    }
                    tr:hover{
                        background-color: #262829;
                        color: #fff;
                    }
                }
            }
        }
    }
</style>
